import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Collection } from 'src/app/interfaces/collection';
import { Page } from 'src/app/interfaces/page';
import { CollectionsService } from 'src/app/services/collections.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss'],
})
export class CollectionComponent implements OnInit {
  collection?: Collection;
  pages: Page[] = [];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private firestoreService: FirestoreService,
    public sharedService: SharedService,
    private collectionsService: CollectionsService
  ) {}

  ngOnInit(): void {
    this.subscribeToRoute();
  }

  // if uid exists and is different than set page
  private subscribeToRoute(): void {
    this.route.params.subscribe((params: Params) => {
      if (params.uid && params.uid !== this.collection?.uid) {
        this.getCollection(params.uid).then(() => this.getPages());
      }
    });
  }

  private getCollection(collectionUid: string): Promise<void> {
    this.collection = undefined;
    return this.firestoreService
      .getDocument(`collections/${collectionUid}`)
      .then((collectionDocSnapshot) => {
        this.collection = collectionDocSnapshot.data();
      });
  }

  private getPages(): void {
    this.pages = [];
    // iterate on each page and push to array
    this.collection.pages?.forEach((page) => {
      this.firestoreService
        .getDocument(`pages/${page.pageUid}`)
        .then((pageDocSnapshot) => {
          const pageData = pageDocSnapshot.data();
          pageData.versionUid = page.versionUid;
          pageData.product.get().then((productDataSnapshot) => {
            pageData.product = productDataSnapshot.data();
          });
          this.pages.push(pageData);
        });
    });
  }

  removePage(page: any): void {
    this.collectionsService.removePage(page, this.collection.uid).then(() => {
      this.getCollection(this.collection.uid).then(() => this.getPages());
    });
  }

  deleteCollection(): void {
    this.firestoreService
      .deleteDocument(`collections/${this.collection.uid}`)
      .then(() => {
        this.location.back();
        this.collectionsService.getCollections();
      });
  }
}
